// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {combineReducers} from 'redux';

import admin from './admin';
import channel from './channel';
import rhs from './rhs';
import posts from './posts';
import modals from './modals';
import emoji from './emoji';
import callhistory from './callhistory';
import callrecording from './callrecording';
import general from './general';
import main from './main';
import contacts from './contacts';
import contactlist from './contactlist';
import meeting from './meeting';
import commhistory from './commhistory';
import chataccessrulelist from './chataccessrulelist';
import voicemail from './voicemail';
import webphone from './webphone';
import layout from './layout';
import presence from './presence';
import sms from './sms';
import conferencecenter from './conferencecenter';
import phonepage from './phonepage';

export default combineReducers({
    admin,
    channel,
    rhs,
    posts,
    modals,
    emoji,
    callhistory,
    callrecording,
    general,
    main,
    contacts,
    contactlist,
    meeting,
    commhistory,
    chataccessrulelist,
    voicemail,
    webphone,
    layout,
    presence,
    sms,
    conferencecenter,
    phonepage,
});
